import styled from "styled-components";

export const StyledListedAddressResultContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
`;
